import { ITariff } from '~/src/entities/formattedTariff';

interface ITariffsFilter {
    constructorTariffs: ITariff[],
    tariffs: ITariffsResult[],
}

export interface ITariffsResult {
    channels: string,
    price: string,
    speed: string,
    title: string,
    url: string,
    salePackageId: string,
    offerContents?: string,
    additionalProducts?: string,
    buttonText?: string,
}

interface IFilterAndTransformTariffs {
    tariffs: ITariff[],
    baseTransformFunction: (tariff: ITariff) => ITariffsResult,
}
export const filterAndTransformTariffs = ({
    tariffs,
    baseTransformFunction,
}: IFilterAndTransformTariffs): ITariffsFilter =>
    tariffs.reduce((acc: ITariffsFilter, tariff: ITariff): ITariffsFilter => {
        tariff.alias === 'constructor'
            ? acc.constructorTariffs.push(tariff)
            : acc.tariffs.push(baseTransformFunction(tariff));
        return acc;
    }, { constructorTariffs: [], tariffs: [] });

